import acceptjs from './acceptjs.js';
import squareWebPayments from './squareWebPayments.js';
import simulator from './simulator.js';

/**
 * The browser-side mirror of the backend provider registry, for DIRECT flows —
 * the ones where the card is tokenized here and charged by our server.
 *
 * Adding a provider is one file plus one line, exactly as G6 promises on the
 * server. The checkout page never names a provider.
 */
const TOKENIZERS = {
  'accept.js': acceptjs,
  'square-web-payments': squareWebPayments,
  // Calls nothing, but produces the same shape of token as the others — so the
  // checkout page cannot tell the difference, which is the point.
  simulator,
};

export function getTokenizer(library) {
  const tokenizer = TOKENIZERS[library];
  if (!tokenizer) {
    throw new Error('This payment method is not available right now. Please contact the merchant.');
  }
  return tokenizer;
}

/**
 * Some providers render their own card fields (Square) rather than tokenizing
 * ours (Accept.js). The checkout page asks this to decide whether to draw
 * inputs at all.
 */
export const rendersOwnFields = (library) => Boolean(TOKENIZERS[library]?.rendersOwnFields);
